var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_vm._t("default",null,{"open":_vm.open,"remove":_vm.removeFile,"upload":_vm.uploadFiles}),_vm._v(" "),_c('input',_vm._g(_vm._b({ref:"input",class:_vm.$style.input,attrs:{"type":"file"}},'input',_vm.$attrs,false),_vm.computedListeners))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }